import { Navbar } from "@/components/common/Navbar";
import { PageLoadingState } from "@/components/common/PageLayout";
import { useAuth } from "@/hooks/useAuth";
import { useNavbarVisibility } from "@/hooks/useNavbarVisibility";
import { AppRoutes } from "./AppRoutes";
import { useEffect, useState } from "react";
import { apiFailureBus } from "@/context/apiFailureBus";
import toast from "react-hot-toast";

export function AppShell() {
  const { isLoading } = useAuth();
  const showNavbar = useNavbarVisibility();
  const [networkDown, setNetworkDown] = useState(false);

  useEffect(() => {
    const handleApiFailure = (e: Event) => {
      const customEvent = e as CustomEvent;
      const errorMsg = customEvent.detail?.message || "Network error occurred";
      toast.error(`API Error: ${errorMsg}`, { id: "global-api-error" });
      setNetworkDown(true);
    };

    apiFailureBus.addEventListener('onApiFailure', handleApiFailure);
    return () => {
      apiFailureBus.removeEventListener('onApiFailure', handleApiFailure);
    };
  }, []);

  if (networkDown) {
    return (
      <div className="flex h-dvh flex-col items-center justify-center bg-black p-6 text-center">
        <h2 className="mb-4 text-2xl font-bold text-white">System Unavailable</h2>
        <p className="mb-6 text-gray-400">
          We're having trouble connecting to the servers. Please check your connection or try again later.
        </p>
        <button 
          onClick={() => window.location.reload()}
          className="rounded-md bg-white px-4 py-2 text-sm font-medium text-black hover:bg-gray-200"
        >
          Reload App
        </button>
      </div>
    );
  }

  return (
    <div className="flex h-dvh flex-col overflow-hidden bg-black">
      {showNavbar && <Navbar />}
      <main className="flex min-h-0 flex-1 flex-col overflow-x-hidden overflow-y-auto">
        {isLoading ? <PageLoadingState /> : <AppRoutes />}
      </main>
    </div>
  );
}